export default __webpack_public_path__ + "audio/woosh.e8ce10cb.mp3";